<template>
  <el-row justify="center" class="auth-container">
    <el-col :xs="24" :sm="12" :md="8" :lg="6">

      <el-card class="auth-card" shadow="hover">
        <template #header>
          <div class="card-header">
            <h5 class="mb-0 text-center">设置新密码</h5>
          </div>
        </template>

        <el-alert
          v-if="message"
          :title="message"
          type="success"
          show-icon
          :closable="false"
          class="mb-3"
        >
          <el-button type="primary" class="mt-2" @click="$router.push('/login')">
            返回登录
          </el-button>
        </el-alert>

        <el-alert
          v-if="error"
          :title="error"
          type="error"
          show-icon
          :closable="false"
          class="mb-3"
        />

        <el-form
          :model="formData"
          :rules="formRules"
          ref="resetFormRef"
          label-position="top"
          @submit.prevent="handleConfirm"
          v-if="!message"
        >

          <el-form-item label="电子邮箱" prop="email">
            <el-input
              v-model="formData.email"
              disabled
            />
          </el-form-item>

          <el-form-item label="重置令牌" prop="token">
            <el-input
              v-model="formData.token"
              placeholder="请粘贴邮件中的令牌"
            />
          </el-form-item>

          <el-form-item label="新密码" prop="password">
            <el-input
              v-model="formData.password"
              type="password"
              show-password
              placeholder="请输入新密码"
            />
          </el-form-item>

          <el-form-item label="确认新密码" prop="password_confirm">
            <el-input
              v-model="formData.password_confirm"
              type="password"
              show-password
              placeholder="请再次输入新密码"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="w-100"
              size="large"
              @click="handleConfirm"
              :loading="isLoading">
              {{ isLoading ? '正在设置...' : '设置新密码' }}
            </el-button>
          </el-form-item>
        </el-form>

      </el-card>

    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios';
// 【V4.0 新增】导入 Element Plus 消息提示
import { ElMessage } from 'element-plus';

export default {
  name: 'ResetPasswordConfirmView',
  data() {
    // 【V4.0 新增】自定义验证规则
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.formData.password) {
        callback(new Error("两次输入的新密码不一致！"));
      } else {
        callback();
      }
    };

    return {
      formData: {
        email: this.$route.query.email || '', // 从 URL query 获取 email
        token: '',
        password: '',
        password_confirm: '',
      },
      isLoading: false,
      message: null,
      error: null,

      // 【V4.0】 Element Plus 表单验证规则
      formRules: {
        token: [
          { required: true, message: '令牌不能为空。', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '新密码不能为空。', trigger: 'blur' },
        ],
        password_confirm: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
      }
    };
  },
  methods: {
    /**
     * handleSubmit() (已【重构】为使用 el-form 验证)
     */
    async handleConfirm() {
      // 1. 【V4.0】使用 el-form 的 'validate' 方法
      this.$refs.resetFormRef.validate(async (valid) => {
        if (!valid) {
          ElMessage({ type: 'error', message: '请检查您的表单是否填写完整。' });
          return false;
        }

        // --- 验证通过, 开始提交 ---
        this.isLoading = true;
        this.message = null;
        this.error = null;

        try {
          // 2. 【POST】请求 (保持不变)
          const payload = {
            email: this.formData.email,
            token: this.formData.token,
            password: this.formData.password
          };
          await axios.post('/api/password_reset/confirm/', payload);

          // 3. 处理成功
          this.message = '密码已成功重置！您现在可以使用新密码登录了。';

        } catch (err) {
          // 4. 处理失败
          console.error('密码重置确认失败:', err);
          if (err.response && err.response.data) {
            this.error = Object.values(err.response.data).join(' ');
          } else {
            this.error = '操作失败。令牌可能已过期或无效。';
          }
        } finally {
          this.isLoading = false;
        }
        // --- 提交结束 ---
      });
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 (与 LoginView 共享) --- */
.auth-container {
  padding-top: 5rem;
}
.auth-card {
  border-radius: 8px;
}
.card-header h5 {
  font-weight: 600;
  color: var(--el-text-color-primary);
}
.w-100 {
  width: 100%;
}
.mb-0 { margin-bottom: 0; }
.mb-3 { margin-bottom: 1.25rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-3 { margin-top: 1rem; }
.text-center { text-align: center; }
.text-muted {
  font-size: 0.9rem;
  color: var(--el-text-color-secondary);
}
</style>